import Swiper from 'swiper/bundle';

(function ($) {

    initializeSwipers();

    function initializeSwipers() {
        let slidersElements = document.querySelectorAll(".section-accordion-02 .gallery-slider");

        slidersElements.forEach((sliderElement) => {
            let sliderId = sliderElement.getAttribute('id');
            let dataId = sliderElement.getAttribute('data-id');

            if (sliderId) {

                let videoSwiper = new Swiper("#" + sliderId, {
                    spaceBetween: 16,
                    slidesPerView: "auto",
                    loop: false,
                    updateOnWindowResize: true,
                    navigation: {
                        nextEl: `.accordion-02-slider-swiper-button-next-${dataId}`,
                        prevEl: `.accordion-02-slider-swiper-button-prev-${dataId}`
                    },
                });

            }
        });
    }


    $(".section-accordion-02 .panel-heading").on("click", function (event) {
        let $accordion = $(this).closest(".panel-accordion")
        let $collapse = $accordion.find(".panel-collapse");
        if ($collapse.hasClass("show")) {
            $collapse.slideUp().removeClass("show");
            $accordion.removeClass('opened');
            setTimeout(() => {
                document.dispatchEvent(new CustomEvent("accordionClosed", {
                    detail: { id: $accordion.attr("id") }
                }));
            }, 500)
        } else {
            $collapse.slideDown().addClass("show");
            $accordion.addClass('opened');

            setTimeout(() => {
                document.dispatchEvent(new CustomEvent("accordionOpened", {
                    detail: { id: $accordion.attr("id") }
                }));
            }, 500)
        
        }
    });

})(jQuery);